import { JobsClient } from './JobsClient'
import settings from 'settings'

export const jobsClient = new JobsClient(`${settings.apiBaseUrl}/v3/sql`)

export * from './types'
